<template>
<div class="cockpit-container">
  <div class="p" ref="p">
    <div class="p-header">
      <div>
        <div class="p-header__school">{{schoolName}}</div>
        <div class="p-header__cockpit">精准教学驾驶舱</div>
      </div>
      <el-tabs v-model="activeName"
        @tab-click="onTabClick" ref="pr" class="p-r i-tab" :class="offsetClass">
        <el-tab-pane
          :label="item.label"
          :name="item.name"
          v-for="item in tabList"
          :key="item.name">
            <component
              ref="PreviewRecord"
              :dataList="dataList"
              :mentallyList="mentallyList"
              :is="item.component"
            />
          </el-tab-pane>
      </el-tabs>
      <div class="p-select">
        <el-select popper-class="selectFrom" v-model="value" placeholder="" @change="timeChange">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
        <div v-if="fullScreenShow" class="p-select__out" @click="handleOpen"></div>
        <div v-else  class="p-select__shrink" @click="exitScreen"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { CRM_USER } from '@/config/storage';
import dayjs from 'dayjs';
import MentallyAdapt from './components/mentally-adapt.vue';
import AccurateTeacher from './components/accurate-teacher.vue';
import { unlocking } from '@/utils/access-control';
import { getEvaluationDetail, getAiEvaluationDetail } from '@/api/pt';

export default {
  name: 'Cockpit',
  components: {
    MentallyAdapt,
    AccurateTeacher,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem(CRM_USER)) || {};
    return {
      schoolName: userInfo.campusName,
      activeName: 'MentallyAdapt',
      offsetClass: 'l-0',
      fullScreenShow: true,
      isshow: false,
      tabList: [],
      options: {},
      dataList: {},
      mentallyList: [],
      value: '',
      createTime: userInfo.createTime,
    };
  },
  mounted() {
    this.options = this.getMonth();
    this.authorityManagement();
    // 按钮权限 精准驾驶舱 精准驾驶舱—智适应学情 cockpit_adaptationsituation
    // 按钮权限 精准驾驶舱 精准驾驶舱—精准测评学情 cockpit_ievaluationsituation
    const that = this;
    window.onresize = () => {
      setTimeout(() => {
        if (!that.fullscreenElement()) {
          that.exitScreen();
        }
      });
    };
  },
  methods: {
    fullscreenElement() {
      const fullscreenEle = document.fullscreenElement || document.mozFullScreenElement
       || document.webkitFullscreenElement;
      return fullscreenEle;
    },
    handleOpen() {
      const el = document.documentElement;
      const rfs = el.requestFullScreen
      || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
      if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(el);
      }
      this.isshow = false;
      this.fullScreenShow = false;
    },
    exitScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isshow = true;
      this.fullScreenShow = true;
    },
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
    },
    async getEvaluationDetail() { // 精准教学
      const res = await getEvaluationDetail({
        start_date: this.value ? this.value.replace('年', '-').replace('月', '').replace(/-(\d)(?!\d)/g, '-0$1') : '',
      });
      this.dataList = res.data;
    },
    async getAiEvaluationDetail() { // 智适应
      const res = await getAiEvaluationDetail({
        date: this.value ? this.value.replace('年', '-').replace('月', '').replace(/-(\d)(?!\d)/g, '-0$1') : '',
      });
      this.mentallyList = res.data;
    },
    getMonth() { // 获取时间列表
      const beforeMoth = dayjs(this.createTime).add(1, 'month');
      const getmoth = dayjs(new Date()).add(1, 'month');
      if (getmoth.$M === 0) {
        this.value = `${getmoth.$y - 1}年${12}月`;
        this.current_time = `${getmoth.$y - 1}-${12}`;
      } else {
        this.value = `${getmoth.$y}年${getmoth.$M}月`;
        this.current_time = `${getmoth.$y}-${getmoth.$M}`;
      }
      const list = [];
      if (beforeMoth.$y <= 2021 && beforeMoth.$M < 9) {
        beforeMoth.$M = 9;
      }
      if (beforeMoth.$y < getmoth.$y) {
        for (let i = beforeMoth.$M; i <= 12; i += 1) {
          list.unshift({
            value: `${getmoth.$y - 1}年${i}月`,
            label: `${getmoth.$y - 1}年${i}月`,
          });
        }
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else if (beforeMoth.$y === getmoth.$y && beforeMoth.$M === 0) {
        list.unshift({
          value: `${beforeMoth.$y - 1}年${12}月`,
          label: `${beforeMoth.$y - 1}年${12}月`,
        });
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else {
        for (let i = beforeMoth.$M; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      }
      return list;
    },
    timeChange() {
      console.log(this.value, 'value');
      this.authorityManagement();
    },
    authorityManagement() {
      const adaptationsituation = unlocking('cockpit_adaptationsituation');
      const ievaluationsituation = unlocking('cockpit_ievaluationsituation');
      console.log(adaptationsituation, ievaluationsituation);
      if (adaptationsituation && !ievaluationsituation) {
        this.tabList = [{
          label: '智适应学情',
          name: 'MentallyAdapt',
          component: MentallyAdapt,
        }];
        this.getAiEvaluationDetail();
      }
      // if (ievaluationsituation && !adaptationsituation) {
      //   this.tabList = [{
      //     label: '精准教学学情',
      //     name: 'AccurateTeacher',
      //     component: AccurateTeacher,
      //   }];
      //   this.activeName = 'AccurateTeacher';
      //   this.getEvaluationDetail();
      // }
      if (ievaluationsituation && adaptationsituation) {
        this.tabList = [
          {
            label: '智适应学情',
            name: 'MentallyAdapt',
            component: MentallyAdapt,
          },
          // {
          //   label: '精准教学学情',
          //   name: 'AccurateTeacher',
          //   component: AccurateTeacher,
          // },
        ];
        this.getEvaluationDetail();
        this.getAiEvaluationDetail();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cockpit-container {
  width: 100%;
  height: 100%;
  overflow-x: auto;
}
  .p{
    position: relative;
    min-width: 1920px;
    // height: 100vh;
    background: url('../images/cockpit-bg.jpg') no-repeat center;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #F5F5FF;
    &-header {
      width: 100%;
      padding-top: 100px;
      min-height: 181px;
      background: url('../images/cockpit-header.png') no-repeat top center / contain;
      &__school {
        position: absolute;
        left: 50%;
        top: 20px;
        transform: translateX(-50%);
        font-weight: 500;
        font-size: 38px;
      }
      &__cockpit {
        position: absolute;
        left: 50%;
        top: 120px;
        transform: translateX(-50%);
        font-weight: 500;
        font-size: 29px;
      }
    }
    &-r {
      box-sizing: border-box;
      position: relative;
      padding: 0 48px;
    }
    &-select {
      position: absolute;
      display: flex;
      right: 80px;
      top: 100px;
      /deep/ {
        .el-select {
          width: 130px;
          height: 44px;
          .el-input__inner {
            background: url('../images/cockpit-time.png') no-repeat top left / contain;
            border: none;
            color: #F5F5FF;
            .el-icon-arrow-up:before {
              content: '',
            }
          }
        }
      }
      &__out {
        position: relative;
        width: 40px;
        height: 40px;
        margin-left: 30px;
        background: url('../images/full-screen.png') no-repeat top left / cover;
      }
      &__shrink {
        position: relative;
        width: 40px;
        height: 40px;
        margin-left: 50px;
        background: url('../images/shrink.png') no-repeat top left / cover;
      }
    }
    .selectFrom {
  .el-select-dropdown {
    background: rgba(53, 76, 179, 1) !important;
  }
}
    // element tag 样式覆盖
    .i-tab {
        /deep/ {
          .el-tabs__item {
            position: relative;
            top: -14px;
            font-size: 30px;
            width: 100px;
            text-align: center;
            height: 56px;
            color: #F5F5FF;
            line-height: 56px;
            padding: 0 !important;
            margin: 0 60px;
            &.is-active {
              color: #00DEFF;
            }
          }
          .el-tabs__nav-wrap {
            overflow: visible;
            display: flex;
            &::after {
              z-index: -20;
            }
          }
          .el-tabs__nav-scroll {
            overflow: visible;
          }
          .el-tabs__active-bar {
            // background-color: rgba(25, 137, 250, 1);
            background: linear-gradient(337deg, #D63CFF 0%, #78B6FF 100%);
            height: 9px;
            border-radius: 9px;
            width: 44px !important;
          }
        }
      }
      .l-0 /deep/{
        .el-tabs__active-bar {
          left: 114px;
        }
      }
      .l-1 /deep/ {
        .el-tabs__active-bar {
          left: 246px;
        }
      }
}
</style>
